// pages/Margin.js
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_CONFIG } from "../app-config";
import BannerCarousel from "../components/banner-carousel";
import SidebarHeader from "../components/SidebarHeader";
import BottomNav from "../components/bottom-menu";
import toast, { Toaster } from 'react-hot-toast';
import { apiCall } from "../utils/api";
import Bmnemonic_PNG from "../assets/image/Bmnemonic_PNG.png"
import { FiArrowLeft } from "react-icons/fi";

const COLORS = APP_CONFIG.colors;

function Margin() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [mobileOperators, setMobileOperators] = useState([]);
    const [dthOperators, setDthOperators] = useState([]);

    useEffect(() => {
        const fetchMargin = async () => {
            try {
                const result = await apiCall("margin", {}, true);
                if (result.status === true) {
                    const prepaidOperators = result.margin.filter(item => item.category === "Prepaid");
                    const dthOperators = result.margin.filter(item => item.category === "DTH");

                    setMobileOperators(prepaidOperators);
                    setDthOperators(dthOperators);
                } else {
                    toast.error(result.message || "An error occurred. Please try again.");
                }
            } catch (error) {
                toast.error("Network error. Please try again.");
            } finally {
                setLoading(false);
            }
        }
        fetchMargin();
    }, [])

    const formatCommission = (commission, commissionType) => {
        if (!commission) return "0%";
        if (commissionType === "1") {
            return `${commission}%`;
        }
        return `₹${commission}`;
    };

    if (loading) {
        return (
            <SidebarHeader>
                <div className="flex items-center gap-3 pb-4">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-200 hover:bg-gray-300 transition"
                    >
                        <FiArrowLeft className="text-xl" />
                    </button>
                    <h1 className="text-lg font-semibold text-gray-800">
                        Margin
                    </h1>
                </div>
                <div className="max-w-7xl mx-auto mb-16">
                    <div className="text-center py-12">
                        <div className="w-10 h-10 rounded-full animate-spin mx-auto mb-4" style={{ border: `3px solid ${COLORS.primaryColor}33`, borderTopColor: COLORS.primaryColor }} />
                        <div className="text-sm font-medium" style={{ color: COLORS.textSecondary }}>
                            Loading margin...
                        </div>
                    </div>
                </div>
                <div className="lg:hidden">
                    <BottomNav />
                </div>
            </SidebarHeader>
        );
    }

    return (
        <SidebarHeader>
            <div className="flex items-center gap-3 pb-4">
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-200 hover:bg-gray-300 transition"
                >
                    <FiArrowLeft className="text-xl" />
                </button>
                <h1 className="text-lg font-semibold text-gray-800">
                    Margin
                </h1>
            </div>
            <div className="max-w-7xl mx-auto mb-16">
                <div className="rounded-2xl p-4 md:p-6"
                    style={{
                        background: COLORS.bgColor,
                        boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
                        border: `1px solid ${COLORS.borderColor}`,
                    }}>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* Mobile Recharge Section */}
                        {mobileOperators.length > 0 && (
                            <div>
                                <h3 className="text-sm font-bold uppercase tracking-wide mb-3" style={{ color: COLORS.textSecondary }}>
                                    Mobile Recharge
                                </h3>
                                <div className="rounded-xl overflow-hidden" style={{ background: COLORS.surfaceColor, border: `1px solid ${COLORS.borderColor}` }}>
                                    {mobileOperators.map((item, index) => (
                                        <div
                                            key={item.operator_id}
                                            className={`flex items-center justify-between p-4 ${index !== mobileOperators.length - 1 ? 'border-b' : ''
                                                }`}
                                            style={{ borderBottomColor: index !== mobileOperators.length - 1 ? COLORS.borderColor : 'transparent' }}
                                        >
                                            <div className="flex items-center gap-3">
                                                <div className="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center" style={{ background: COLORS.bgColor, border: `1px solid ${COLORS.borderColor}` }}>
                                                    <img src={item.logo} alt={item.biller_name} className="w-full h-full object-contain" />
                                                </div>
                                                <span className="text-sm font-bold" style={{ color: COLORS.textPrimary }}>
                                                    {item.biller_name}
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-1.5">
                                                <span className="text-base font-extrabold" style={{ color: COLORS.primaryColor }}>
                                                    {formatCommission(item.commission, item.commission_type)}
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* DTH Recharge Section */}
                        {dthOperators.length > 0 && (
                            <div>
                                <h3 className="text-sm font-bold uppercase tracking-wide mb-3" style={{ color: COLORS.textSecondary }}>
                                    DTH Recharge
                                </h3>
                                <div className="rounded-xl overflow-hidden" style={{ background: COLORS.surfaceColor, border: `1px solid ${COLORS.borderColor}` }}>
                                    {dthOperators.map((item, index) => (
                                        <div
                                            key={item.operator_id}
                                            className={`flex items-center justify-between p-4 ${index !== dthOperators.length - 1 ? 'border-b' : ''
                                                }`}
                                            style={{ borderBottomColor: index !== dthOperators.length - 1 ? COLORS.borderColor : 'transparent' }}
                                        >
                                            <div className="flex items-center gap-3">
                                                <div className="w-8 h-8 rounded-lg overflow-hidden flex items-center justify-center" style={{ background: COLORS.primaryLight, border: `1px solid ${COLORS.borderColor}` }}>
                                                    <img src={item.logo} alt={item.biller_name} className="w-full h-full object-contain" />
                                                </div>
                                                <span className="text-sm font-semibold" style={{ color: COLORS.textPrimary }}>
                                                    {item.biller_name}
                                                </span>
                                            </div>
                                            <span className="text-sm font-bold" style={{ color: COLORS.primaryColor }}>
                                                {formatCommission(item.commission, item.commission_type)}
                                            </span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>


                    {/* Show message if no data */}
                    {mobileOperators.length === 0 && dthOperators.length === 0 && (
                        <div className="text-center mt-12" style={{ color: COLORS.textSecondary }}>
                            No margin data available
                        </div>
                    )}
                </div>
            </div>

            <Toaster />

            {/* Bottom Navigation - Hidden on desktop (lg and above) */}
            <div className="lg:hidden">
                <BottomNav />
            </div>
        </SidebarHeader>
    );
}

export default Margin;